import { render, staticRenderFns } from "./AlertTrend.vue?vue&type=template&id=5face80e&scoped=true"
import script from "./AlertTrend.vue?vue&type=script&lang=js"
export * from "./AlertTrend.vue?vue&type=script&lang=js"
import style0 from "./AlertTrend.vue?vue&type=style&index=0&id=5face80e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5face80e",
  null
  
)

export default component.exports